import styled from 'styled-components'

export const BranchCardStyle = styled.div`
  margin-top: 20px;
  border-top: 1px solid ${props => props.borderColor || props.theme.Gray90};
  padding: ${props => props.padding || '12px'};
  background-color: ${props => props.theme.white};
`
